/**
 * Optimisation d'images via le proxy gratuit wsrv.nl (Cloudflare).
 * Convertit en WebP, redimensionne et réduit la qualité — sans perte visible.
 *
 * Exemple :
 *  optimizedImage("https://customer-assets.emergentagent.com/.../photo.jpg", { w: 1600 })
 *  => "https://wsrv.nl/?url=customer-assets...&w=1600&q=78&output=webp"
 */
export const optimizedImage = (url, opts = {}) => {
  if (!url) return url;
  const { w = 1600, q = 78, output = "webp" } = opts;

  // strip protocol — wsrv attend l'URL sans https://
  const clean = url.replace(/^https?:\/\//, "");

  return `https://wsrv.nl/?url=${encodeURIComponent(clean)}&w=${w}&q=${q}&output=${output}&we`;
};
